import { AbstractControl, ValidatorFn } from '@angular/forms';

export function  requestedTotalValuationValidator(releasedValCost: any):ValidatorFn {
    return (control: AbstractControl): {[key: string]: boolean} | null => {
        if (control.value !== null){
			let reqTotalVal = control.value;
			
			console.log('req total val == ', reqTotalVal);

			console.log('released val cost == ', releasedValCost);

            if(reqTotalVal <= releasedValCost){
				console.log('Inside expcted here');
                return {notAcceptable : true}; 
            }
           
            
        }
        return null; 
    }
}
